// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"2e92f365","282":"8d08efc3","343":"e04269aa","355":"49c64157","681":"78b3494a","697":"b54061ce","795":"ff34ac5b"}[chunkId] + ".chunk.js";
};